import { VegaBox, VegaFlex } from '@globalpayments/vega-react';
import ComponentStatuses from '../../components/componentStatuses';
import QueueStatuses from '../../components/queueStatus';

const Status = () => {
  return (
    <VegaBox width="100%">
      <VegaFlex direction="col" gap="size-32">
        <ComponentStatuses />
        <QueueStatuses />
      </VegaFlex>
    </VegaBox>
  );
};

export default Status;
